import axios from 'axios';

// Setup api client
const apiClient = axios.create({
  baseURL: payload.services.userservice.url
});

export default {
  async getForUser(token) {
    return (await apiClient.get('/api/v1/product-sheet/favorite', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })).data;
  },

  async getForUserAndProduct(token, prd) {
    return (await apiClient.get(`/api/v1/product-sheet/favorite/?productIds=${prd}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })).data;
  },

  async saveFavorite(token, productId, documentTypes) {
    return (await apiClient.post('/api/v1/product-sheet/favorite', {
      productId,
      documentTypes
    }, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })).data;
  },

  async deleteFavorite(token, id) {
    (await apiClient.delete(`/api/v1/product-sheet/favorite/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }));
  },
};
